import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnNU: CultureInfo = {
  name: 'en-NU',
  displayName: 'English (Niue)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-NU',
  parent: CultureInfoEn
};
